import { useMediaQuery } from "@kyan/ui";

import { useEquityButtonFeatureFlag } from "#/hooks/featureFlags/useEquityButtonFeatureFlag";
import { useShowEquityModal } from "#/store/app/equityModal/showEquityModal";

export const useDepositController = () => {
  const { isLg } = useMediaQuery();
  const { setShowEquityModal } = useShowEquityModal();
  const { isEquityButtonEnabled, equityButtonTitle, equityButtonTooltip } =
    useEquityButtonFeatureFlag();

  return {
    isLg,
    title: equityButtonTitle,
    tooltip: equityButtonTooltip,
    isDisabled: !isEquityButtonEnabled,
    setShowEquityModal,
  };
};
